var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkChain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-fae8f5d4-c837-4534-b30c-6d94725ebaff)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.836 9.404c0-.201.08-.394.223-.536l3.715-3.715a.758.758 0 0 1 1.072 1.072L6.132 9.94a.755.755 0 0 1-.536.22.755.755 0 0 1-.76-.756zM14.014.985a3.39 3.39 0 0 1 0 4.78l-2.93 2.937a.755.755 0 0 1-1.071 0 .755.755 0 0 1 0-1.072l2.93-2.93a1.865 1.865 0 0 0 0-2.643 1.903 1.903 0 0 0-2.643 0l-2.93 2.93a.758.758 0 0 1-1.072-1.072L9.235.985a3.39 3.39 0 0 1 4.78 0zm-6.478 9.121a.758.758 0 0 1 1.072 1.073l-2.937 2.93a3.383 3.383 0 0 1-4.78-4.78l2.93-2.938a.758.758 0 0 1 1.072 1.073l-2.93 2.93a1.865 1.865 0 0 0 0 2.642 1.903 1.903 0 0 0 2.643 0l2.93-2.93z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkChain);
export default __webpack_public_path__ + "static/media/link-chain.63b340992036c45f33fdd74bba02cc50.svg";
export { ForwardRef as ReactComponent };